import { render } from "./BannerArea.vue?vue&type=template&id=6e068a49"
import script from "./BannerArea.vue?vue&type=script&lang=js"
export * from "./BannerArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__